import React, { useState } from 'react';
import { ImExit } from 'react-icons/im';
import { useDispatch } from 'react-redux';
import { logoutAction } from '../../redux/actions/authActions';

const HeaderMenu = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleUserLogout = () => {
    setLoading(true);
    dispatch(logoutAction());
    setLoading(false);
  };

  return (
    <div className="absolute right-0 mt-4 flex w-40 sm:w-60 flex-col rounded-sm border border-stroke bg-white">
      <button
        onClick={() => handleUserLogout()}
        disabled={loading}
        className="flex items-center gap-3.5 py-4 px-6 duration-300 ease-in-out hover:text-contrast1"
      >
        <ImExit />
        Вихід
      </button>
    </div>
  );
};

export default HeaderMenu;
